export default {
    nav: 'Navigation',
    phone: 'Phone Number',
    email: 'Email',
    transPwd: 'Trading Password',
    logout: 'Logout',
    confirmLogout: 'Confirm logout?',
    logoutTips: 'After logging out, you will need to log in again next time you open the account',
    noSaveRecord: 'This operation will not save your current records',
    confirm: 'Confirm',

    phoneConsult: 'Phone Consultation',
    onlineService: 'Contact Customer Service',
    WeChatService: 'WeChat Customer Service',

    assets: 'Assets',
    assetsHome: 'Assets Home',
    deposit: 'Deposit Funds',
    withdraw: 'Withdraw Funds',
    currencyExchange: 'Currency Exchange',
    orderRecords: 'Order Records',
    finance: 'Finance',
    financeHome: 'Finance Home',
    cashbox: 'Star Wealth Treasure',
    publicFund: 'Public Fund',
    bill: 'Bill',
    bond: 'Bond',

    // contact组件
    contact: 'Contact Us',
    understood: 'Understood',
    mainlandService: 'Mainland Customer Service',
    hongKongService: 'Hong Kong Customer Service',
}
